import Vue from 'vue'
import Collect, { BuryPointModules, BuryPoint } from '$utils/collect'

// 引入模块
// import example from './modules/example'
import act from './modules/example'

Vue.use(Collect)

// 不要使用 example 作为命名空间
const modules: BuryPointModules = {
  // 罗列埋点模块
  // example
  act
}

if (process.env.NODE_ENV === 'dev') {
  modules.example = require('./modules/example').default
}

const buryPoint = new BuryPoint({
  modules,
})

export default buryPoint
